import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as m, unref as e, renderSlot as V, createElementVNode as n, createCommentVNode as i } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, f = { key: 3 }, k = { key: 4 }, M = { key: 5 }, h = {
  name: "ScalarIconDiceOne"
}, _ = /* @__PURE__ */ d({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: A, weight: l } = p(s);
    return (H, t) => (a(), o("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(A)), [
      V(H.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", u, t[0] || (t[0] = [
        n("path", { d: "M192,28H64A36,36,0,0,0,28,64V192a36,36,0,0,0,36,36H192a36,36,0,0,0,36-36V64A36,36,0,0,0,192,28Zm12,164a12,12,0,0,1-12,12H64a12,12,0,0,1-12-12V64A12,12,0,0,1,64,52H192a12,12,0,0,1,12,12Zm-60-64a16,16,0,1,1-16-16A16,16,0,0,1,144,128Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", Z, t[1] || (t[1] = [
        n("path", {
          d: "M216,64V192a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V64A24,24,0,0,1,64,40H192A24,24,0,0,1,216,64Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M192,32H64A32,32,0,0,0,32,64V192a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V64A32,32,0,0,0,192,32Zm16,160a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H192a16,16,0,0,1,16,16Zm-68-64a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", g, t[2] || (t[2] = [
        n("path", { d: "M192,32H64A32,32,0,0,0,32,64V192a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V64A32,32,0,0,0,192,32ZM128,140a12,12,0,1,1,12-12A12,12,0,0,1,128,140Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", f, t[3] || (t[3] = [
        n("path", { d: "M192,34H64A30,30,0,0,0,34,64V192a30,30,0,0,0,30,30H192a30,30,0,0,0,30-30V64A30,30,0,0,0,192,34Zm18,158a18,18,0,0,1-18,18H64a18,18,0,0,1-18-18V64A18,18,0,0,1,64,46H192a18,18,0,0,1,18,18Zm-72-64a10,10,0,1,1-10-10A10,10,0,0,1,138,128Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", k, t[4] || (t[4] = [
        n("path", { d: "M192,32H64A32,32,0,0,0,32,64V192a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V64A32,32,0,0,0,192,32Zm16,160a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H192a16,16,0,0,1,16,16Zm-68-64a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", M, t[5] || (t[5] = [
        n("path", { d: "M192,36H64A28,28,0,0,0,36,64V192a28,28,0,0,0,28,28H192a28,28,0,0,0,28-28V64A28,28,0,0,0,192,36Zm20,156a20,20,0,0,1-20,20H64a20,20,0,0,1-20-20V64A20,20,0,0,1,64,44H192a20,20,0,0,1,20,20Zm-76-64a8,8,0,1,1-8-8A8,8,0,0,1,136,128Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
